module.exports = __webpack_public_path__ + "static/eikenbos-6e8f3d7da435575c07c351aba97e71ff.jpg";